/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They are the empirically established amounts of double-stranded DNA, single-stranded DNA and single-stranded RNA that give an absorbance of 1 at 260 nm in a 1 cm path length.`)
};

const es_od_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son las cantidades establecidas empíricamente de ADN bicatenario, ADN monocatenario y ARN monocatenario que dan una absorbancia de 1 a 260 nm en un camino óptico de 1 cm.`)
};

const de_od_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es sind die empirisch ermittelten Mengen an doppelsträngiger DNA, einzelsträngiger DNA und einzelsträngiger RNA, die bei einer Weglänge von 1 cm eine Absorption von 1 bei 260 nm ergeben.`)
};

const nl_od_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit zijn de empirisch vastgestelde hoeveelheden dubbelstrengs DNA, enkelstrengs DNA en enkelstrengs RNA die een absorptie van 1 geven bij 260 nm bij een weglengte van 1 cm.`)
};

const fr_od_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce sont les quantités établies empiriquement d'ADN double brin, d'ADN simple brin et d'ARN simple brin qui donnent une absorbance de 1 à 260 nm sur un trajet de 1 cm.`)
};

const it_od_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sono le quantità stabilite empiricamente di DNA a doppio filamento, DNA a singolo filamento e RNA a singolo filamento che danno un'assorbanza di 1 a 260 nm con un cammino ottico di 1 cm.`)
};

const pt_br2_od_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`São as quantidades estabelecidas empiricamente de DNA de fita dupla, DNA de fita simples e RNA de fita simples que produzem uma absorbância de 1 a 260 nm em um caminho óptico de 1 cm.`)
};

const pt_od_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`São as quantidades estabelecidas empiricamente de ADN de cadeia dupla, ADN de cadeia simples e ARN de cadeia simples que produzem uma absorvância de 1 a 260 nm num percurso ótico de 1 cm.`)
};

const ja_od_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これらは、光路長1 cmで260 nmの吸光度1を与える二本鎖DNA、一本鎖DNA、一本鎖RNAの量として経験的に定められた値です。`)
};

const zh_od_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这些是通过实验确定的数值，表示在 1 cm 光程下使 260 nm 处吸光度为 1 所需的双链 DNA、单链 DNA 和单链 RNA 的量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_faq_a2", locale)
	if (locale === "en") return en_od_faq_a2(inputs)
	if (locale === "es") return es_od_faq_a2(inputs)
	if (locale === "de") return de_od_faq_a2(inputs)
	if (locale === "nl") return nl_od_faq_a2(inputs)
	if (locale === "fr") return fr_od_faq_a2(inputs)
	if (locale === "it") return it_od_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_od_faq_a2(inputs)
	if (locale === "pt") return pt_od_faq_a2(inputs)
	if (locale === "ja") return ja_od_faq_a2(inputs)
	return zh_od_faq_a2(inputs)
};